import React from "react";
import {withTranslation} from "react-i18next";
import { Link } from 'react-router-dom';
import RoutePath from '../../resource/RoutePath'
import { findTimeString } from "../../common/Util";
import { Markup } from "interweave"
class OutRaceComp  extends React.Component {
	constructor(props) {
        super(props);
		this.state = {
		};
	}

	render() {
		const {t} = this.props;
		return (
			<div className="content-wrap sub-content">
				<div className="visual-slide-wrap">
					<div className="visual-slide-list">
						<div className="slide">
							<div className="img">
								<img src="https://asset.981park.com/www/common/web/img/sub/play/slide-race-9811.png" alt="9.81 파크의 대표 액티비티, 친환경 그래비티 레이싱!"/>
							</div>
						</div>			
					</div>
					
					<div className="visual-slide-text">
						<div className="inner">
							<div className="con">
								<div className="text-wrap color1">
									<p className="s-text typo1">RACE 981</p>
									<p className="m-text">{t('OutRaceComp_title_1')} <br/> {t('OutRaceComp_title_2')}</p>
								</div>
							</div>	
						</div>	
					</div>
				</div>
				<div className="detail-con-wrap">
					<div className="inner">
						<div className="list">
							<div className="list-con">
								<p className="lg-ttl">{t('OutRaceComp_c_title_1')}</p>
								<div className="img">
									<img src="https://asset.981park.com/www/common/web/img/sub/play/img-race-9811.png" alt="RACE 981"/>
								</div>
								<div className="txt-wrap">
									<div className="txt">
										{t('OutRaceComp_c_sub_1_1')}<br/>
										{t('OutRaceComp_c_sub_1_2')}<br/><br/>

										{t('OutRaceComp_c_sub_1_3')}<br/>
										{t('OutRaceComp_c_sub_1_4')}<br/>
										{t('OutRaceComp_c_sub_1_5')}<br/><br/>

										{t('OutRaceComp_c_sub_1_6')}<br/>
										{t('OutRaceComp_c_sub_1_7')}
									</div>
								</div>
								<div className="button-wrap">
									<Link to={`/`+RoutePath.RACE981} className="link-detail-more">{t('OutRaceComp_c_sub_1_8')}</Link>
								</div>
							</div>	
							
							<div className="list-con">
								<p className="lg-ttl">{t('OutRaceComp_c_title_2')}</p>
								<div className="img">
									<img src="https://asset.981park.com/www/common/web/img/sub/play/img-race-9812.png" alt="이용방법"/>
								</div>
								<div className="txt-wrap">
									<div className="txt">
										{t('OutRaceComp_c_sub_2_1')} <br/>
										{t('OutRaceComp_c_sub_2_2')}
									</div>
								</div>
								<div className="button-wrap">
									<Link to={`/`+RoutePath.ACTIVITY} style={{cursor: "pointer"}} className="link-detail-more">{t('OutRaceComp_c_sub_3_8')}</Link>
								</div>
							</div>
							
							<div className="list-con">
								<p className="lg-ttl">{t('OutRaceComp_c_title_3')}</p>
								<div className="list-txt">						
									<ul>
										<li><p className="txt">{t('OutRaceComp_c_sub_3_1')}</p></li>
										<li><p className="txt"><Markup content={t('OutRaceComp_c_sub_3_2')}/></p></li>
										<li><p className="txt"><Markup content={t('OutRaceComp_c_sub_3_4')}/></p></li>
										<li><p className="txt">{t('OutRaceComp_c_sub_3_3')}</p></li>
										<li><p className="txt">{t('OutRaceComp_c_sub_3_5')}</p></li>
									</ul>
									<p className="txt ps-txt">{t('OutRaceComp_c_sub_3_6')}</p>
								</div>
								<div className="button-wrap">
									<Link to={`/`+RoutePath.RULES} style={{cursor: "pointer"}} className="link-detail-more">{t('OutRaceComp_c_sub_3_9')}</Link>
								</div>
							</div>

							<div className="list-con">
								<p className="lg-ttl">{t('OperationComp_c_title_4')}</p>
								<div className="button-wrap">
									<Link to={`/`+RoutePath.OPERATION} style={{cursor: "pointer"}} className="link-detail-more">{t('OperationComp_c_title_4_2')}</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default withTranslation()(OutRaceComp);